export default {
  domain: 'bergheimer.eu.auth0.com',
  clientId: 'tg5nj7D5Ta59ux7E6PMeMkf8p9NmTSu6',
  audience: 'bergheimer-dashboard'
};
